module.exports = __webpack_public_path__ + "static/media/temp_w_domu_off.32c8cac6.svg";